var map = {
	"./Color Fill 1.png": "1011",
	"./anatomy.png": "2b26",
	"./cushioning.png": "4ccc",
	"./flat.png": "75e1",
	"./high.png": "1955",
	"./motion.png": "3b21",
	"./neutral.png": "ba33",
	"./normal.png": "3d71",
	"./pronation.png": "bbe1",
	"./stability.png": "b570",
	"./supination.png": "3781"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "52c4";